import{styled as a}from"@mui/material/styles";const i=a("div")`
  display: flex;
  flex-wrap: wrap;
  margin-top: ${({theme:a})=>a.spacing(6)};

  @media (width <= 600px) {
    display: grid;
    grid-template-rows: auto auto;
  }

  ${({$hasGap:a,theme:i})=>!0===a&&`\n    gap: ${i.spacing(4)};\n  `}
`;export{i as ButtonsContainer};
//# sourceMappingURL=styles.js.map
